export function homeMap() {
    let path = $('.map-states path');
    let googleMap = $('#home-map');
    let markerPin = googleMap.data("marker");
    let markerPinActive = googleMap.data("marker-active");
    let closeMap = $('.close-map');
    let locations;
    path.each((index, el) => {
        let activeStates = el.getAttribute('id').slice(3);
        for (let key in mapData) {
            if (activeStates === key) {
                $(el).addClass('active-state');
            }
        }
    });

    $('.active-state').on('click', function () {
        let activeStates = $(this).attr('id').slice(3);
        locations = mapData[activeStates];
        initMap();
        googleMap.addClass('show');
        closeMap.addClass('show');
    });

    closeMap.on('click', function () {
        $(this).removeClass('show');
        googleMap.removeClass('show');
    });

    function initMap() {
        let markers = [];
        let mapStyle = [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    },
                    {
                        "lightness": 17
                    }
                ]
            }
        ];
        let map = new google.maps.Map(document.getElementById('home-map'), {
            styles: mapStyle,
            maxZoom: 12,
            scrollwheel: false,
            scaleControl: false,
            draggable: !(typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1),
            zoomControl: false,
            disableDoubleClickZoom: true,
            panControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            fullscreenControl: false,
            center: new google.maps.LatLng(locations[0].lat, locations[0].lng)
        });
        let bounds = new google.maps.LatLngBounds();
        let infowindow = new google.maps.InfoWindow();
        let marker, i;

        for (i = 0; i < locations.length; i++) {
            let lat = locations[i].lat;
            let lng = locations[i].lng;
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: map,
                icon: markerPin,
                // title: locations[i].state

            });
            markers.push(marker);
            bounds.extend(marker.position);
            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                let infoWindowContent = "<div class='info-window'>" +
                    "<h5>" + locations[i].title + "</h5>" +
                    "<address>" + locations[i].address + "</address>" +
                    "<a class='get-more' href=" + locations[i].link + ">view property</a>" +
                    "</div>";
                return function () {
                    for (let j = 0; j < markers.length; j++) {
                        markers[j].setIcon(markerPin);
                    }
                    infowindow.setContent(infoWindowContent);
                    infowindow.open(map, marker);
                    marker.setIcon(markerPinActive);
                }
            })(marker, i));

            google.maps.event.addListener(infowindow, 'closeclick', (function (marker, i) {
                return function () {
                    marker.setIcon(markerPin);
                }
            })(marker, i));

            map.fitBounds(bounds);
        }
    }

//tooltip
    let tooltipSpan = document.querySelector('.tooltip-title');
    let mapHolder = document.querySelector(".map-wrap");

    path.mouseenter(function () {
        if ($("body").hasClass("no-touch")) {
            let stateName = this.getAttribute('title');
            tooltipSpan.textContent = stateName;
            tooltipSpan.classList.add("show");

            mapHolder.onmousemove = function (e) {
                let x = e.clientX;
                let y = e.clientY;
                tooltipSpan.style.top = (y - 5) + 'px';
                tooltipSpan.style.left = (x + 20) + 'px';
            };
        }
    }).mouseleave(function () {
        if ($("body").hasClass("no-touch")) {
            tooltipSpan.classList.remove("show");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/homeMap.js